import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "client-page-panel-filters" }
const _hoisted_2 = { class: "client-page-panel-filters__top" }
const _hoisted_3 = { class: "client-page-panel-filters__bottom" }
const _hoisted_4 = { class: "client-page-panel-filters__address" }
const _hoisted_5 = {
  key: 0,
  class: "client-page-panel-filters__tags"
}
const _hoisted_6 = { class: "client-page-panel-filters__tags-item-name" }

import {
	computed,
	nextTick,
	ref,
	watch
} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import CreateEditContactDropdown from "@/components/main/clients-panel/dropdowns/CreateEditContactDropdown.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppSelect, {SelectModelValue} from "@/components/ui-kit/select/AppSelect.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import InlineAddressEditor from "@/components/common/address-selector/InlineAddressEditor.vue";
import { TagEntityType } from "@/models/etc/types";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { useContactsAccess } from "@/composables/useContactsAccess";
import { RequestAddressContainer } from "@/composables/useAddressRequest";

type ContactTypeOption = { label: string, type: number, value: number | string | null, id?: number | null }

type Props = {
	searchStr: string,
	searchedContactId: ContactTypeOption | null,
	contactsTypes: ContactTypeOption[],
	selectedTags: TagWithFrequency[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsBlockPanelFilters',
  props: {
    searchStr: {},
    searchedContactId: {},
    contactsTypes: {},
    selectedTags: {}
  },
  emits: ["update:searchStr", "update-searchedContactId", "update:selected-tags", "drop-tag", "on-search"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props
const { isContactsReadonly } = useContactsAccess()
const filters = ref(props.searchStr);
const selectedValue = ref<SelectModelValue>(props.searchedContactId?.value ?? null);

const $createEditContactModal = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $tagsDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)

const appliedAddress = ref<RequestAddressContainer | null>(null)

const selectItems = computed(() => props.contactsTypes.map(item => ({
	id: item.value as string | number,
	label: item.label,
})))

const updateFilters = (newVal: string) => {
	emit('update:searchStr', newVal)
}
const updateType = (newVal: SelectModelValue) => {
	const type = props.contactsTypes.find(item => item.value === newVal)
	if (type) {
		emit('update-searchedContactId', type)
	}
}

const searchClients = async () => {
	emit('on-search', appliedAddress.value)
}

const showExistContacts = (contacts: string) => {
	filters.value = contacts
	updateFilters(contacts)
}

watch(() => props.searchedContactId, (newVal) => {
	nextTick(() => selectedValue.value = newVal?.value ?? null);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isContactsReadonly))
        ? (_openBlock(), _createBlock(AppResizableDropdown, {
            key: 0,
            position: "left",
            resizable: "",
            "initial-width": 320,
            "initial-height": 398,
            "min-width": 320,
            "max-width": 480,
            "min-height": 398,
            "max-height": 600,
            "close-by-click-outside": false,
            "hide-by-parent-scroll": false,
            "mobile-title": _ctx.$t('contact_create_title'),
            ref_key: "$createEditContactModal",
            ref: $createEditContactModal,
            name: "$createContactModal"
          }, {
            activator: _withCtx(() => [
              _createVNode(AppTooltip, {
                position: "bottom",
                text: _ctx.$t('contacts_create')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "client-page-panel-filters__btn",
                    style: { marginRight: '4px' },
                    name: "plus-bold",
                    width: "22px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            default: _withCtx(() => [
              _createVNode(CreateEditContactDropdown, {
                type: "create",
                onOnClose: _cache[0] || (_cache[0] = ($event: any) => ($createEditContactModal.value.close())),
                onExistContactString: showExistContacts
              })
            ]),
            _: 1
          }, 8, ["mobile-title"]))
        : _createCommentVNode("", true),
      _createVNode(AppInput, {
        modelValue: filters.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters).value = $event)),
        style: { width: '100%' },
        placeholder: _ctx.$t('contacts_search_placeholder'),
        "show-search-button": "",
        onInput: updateFilters,
        onPressEnter: searchClients,
        onSearch: searchClients
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppResizableDropdown, {
        ref_key: "$tagsDropdown",
        ref: $tagsDropdown,
        position: "left",
        "close-by-click-outside": true,
        "max-width": 640,
        "max-height": 436,
        "mobile-title": _ctx.$t('choose_tags'),
        name: "$clientPageContactsTags"
      }, {
        activator: _withCtx(() => [
          _createVNode(AppTooltip, {
            text: _ctx.$t('ui_tag_filter')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "client-page-panel-filters__btn",
                style: { marginRight: '4px' },
                name: "hash",
                width: "18px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer"
              })
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        default: _withCtx(() => [
          _createVNode(AppTagSelector, {
            "model-value": _ctx.selectedTags,
            "entity-type": _unref(TagEntityType).Person,
            mode: "filter",
            "allow-create": "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:selected-tags', $event))),
            onClose: _cache[3] || (_cache[3] = ($event: any) => ($tagsDropdown.value?.close()))
          }, null, 8, ["model-value", "entity-type"])
        ]),
        _: 1
      }, 8, ["mobile-title"]),
      _createVNode(AppSelect, {
        modelValue: selectedValue.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedValue).value = $event)),
        items: selectItems.value,
        style: { flex: 1, minWidth: 0 },
        onSelect: updateType
      }, null, 8, ["modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(InlineAddressEditor, {
        id: 'filter-client',
        modelValue: appliedAddress.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((appliedAddress).value = $event)),
        "always-editing": true
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.selectedTags.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTags, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "client-page-panel-filters__tags-item",
              key: tag.Id
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(tag.Name), 1),
              _createVNode(AppIcon, {
                class: "client-page-panel-filters__tags-item-delete",
                name: "close-bold",
                width: "12px",
                color: "#D2D2D2",
                "hover-color": "#4D4D4D",
                cursor: "pointer",
                onClick: _withModifiers(($event: any) => (emit('drop-tag', tag)), ["stop"])
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})